export default "__VITE_ASSET__CnkNm3IE__"